import { Routes } from '@angular/router';

export const userInfoRoutes: Routes = [
  {
    path: 'user-info',
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/user-info-list-page/user-info-list-page.component'
          ).then((m) => m.UserInfoListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/user-info-detail-page/user-info-detail-page.component'
              ).then((m) => m.UserInfoDetailPageComponent),
          },
        ],
      },
    ],
  },
];
